<template>
  <div>
    Goals -- WIP
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>